import { FieldDataTypeEnum } from './field-data-type.enum';
import { FieldPermission } from './field-permission.enum';
import { FieldPropertyEnum } from './field-property.enum';


export class Fields {
  Data: FieldMinimal[];
  Count: number;
}

export class FieldMinimal {

  constructor(init?: Partial<FieldMinimal>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  FieldId?: number;
  Id: string;
  Global?: string;
  Project?: string;
  Permission?: FieldPermission;
  Prop?: FieldPropertyEnum | string;
  GroupFields?: FieldMinimal[];
  DefaultWidth?: number;
}




export class Field {
    constructor(init?: Partial<Field>) {
      if (init) {
        if (init.Id) {
          this.Id = init.Id;
        }
        if (init.DefaultWidth !== undefined) {
          this.DefaultWidth = init.DefaultWidth;
        }
        if (init.DataType !== undefined) {
          this.DataType = init.DataType;
        }
        if (init.GlobalName !== undefined) {
          this.GlobalName = init.GlobalName;
        }
        if (init.DefaultName !== undefined) {
          this.DefaultName = init.DefaultName;
        }
        if (init.FieldCategory !== undefined) {
          this.FieldCategory = init.FieldCategory;
        }


      }

    }
    Id?: number;
    DefaultWidth?: number;
    DataType?: FieldDataTypeEnum;
    GlobalName?: string;
    DefaultName?: string;
    FieldCategory?: number;
}
